import React, { Component } from 'react';
import { Feed, Button } from 'semantic-ui-react'
import { getOrderKey } from '../../../../config/constants';
import {
    ShowEmail
} from '../DashboardParts'

function ShowFeedUi(props) {

    const updateUI = props.update
        ? <Feed.Event>
            <Feed.Content>
                <Feed.Summary>
                    {props.update.updateText}
                </Feed.Summary>
                <Feed.Meta>
                    <Feed.Like>
                        {props.update.time}
                    </Feed.Like>
                    <ShowEmail updatedBy={props.update.updatedBy} />
                </Feed.Meta>
            </Feed.Content>
        </Feed.Event>
        : ''

    return (
        <div>{updateUI}</div>
    )
}


class AlogoliaOrderUpdateFeed extends Component {
    constructor(props) {
        super(props);
        this.state = {
            updates: []
        }
    }

    componentDidMount() {
       // console.log("upx77830 ++++++++ AlogoliaOrderUpdateFeed componentDidMount");
        if (this.props.order.algoliaOrderUpdates) {
           // console.log("upx77831: AlogoliaOrderUpdateFeed ++++ componentDidMount:" + this.props.order.algoliaOrderUpdates.length);
            this.setState({
                updates: this.props.order.algoliaOrderUpdates
            }, () => console.log("updateset"))
        } else {
           // console.log("upx77832 no update found");
        }
    }

    handleTextChange = (e) => {
        // console.log("upx77860 e.target.name:" + e.target.name);
        // console.log("upx77861 e.target.value:" + e.target.value);

        this.setState({
            updateText: e.target.value
        })
    }

    
    updateCommentFormSubmit = () => {
        // console.log("upx7786 +++++++: updateCommentFormSubmit");
        // console.log("upx77865 this state updateText:" + this.state.updateText);
        // console.log("upx77866 this.props.order.key:" + this.props.order.key);

        this.setState({
            updates: this.props.order.algoliaOrderUpdates
        }, () => console.log("upx77867 updates in state:" + JSON.stringify(this.state.updates, null, 3)))

        // if (this.state.updateText.length > 2) {

        //     let userEmail = this.props.user && this.props.user.email ? this.props.user.email : 'unknown';

        //     if (this.props.order.objectID) {
        //         console.log("ddx372 its alogolia this.props.order.objectID exists:" + this.props.order.objectID);
        //         FbUtils.insertUpdateText(this.props.order.objectID, this.state.updateText, userEmail);
        //         this.setState({
        //             updateText: ""
        //         });
        //     } else if (this.props.order.key) {
        //         console.log("ddx3721 its NORMAL this.props.order.key exists:" + this.props.order.key);
        //         FbUtils.insertUpdateText(this.props.order.key, this.state.updateText, userEmail);
        //         this.setState({
        //             updateText: ""
        //         });
        //     }

        // }
    }

    getOrderUpdateUi = (updates) => {
        console.log("upx7789 +++++++: getOrderUpdateUi");

        let newUi = updates.map((update) =>

        <ShowFeedUi update={update} />
        );

        return newUi;
    }


    render() {
        if (this.props.order.algoliaOrderUpdates) {
           // console.log("upx7784 props.order.algoliaOrderUpdates exists)");

          //  console.log("upx77841 algoliaOrderUpdates size:" + this.props.order.algoliaOrderUpdates.length + " " + getOrderKey(this.props.order) + " " + this.props.order.order_num);

        } else {
           // console.log("upx77842 props.order.algoliaOrderUpdates DOES NOT exist)"+ " " + this.props.order.order_num);

        }

        let updates = '';

        //if (props.orderUpdates && Array.isArray(props.orderUpdates)) {
        if (this.props.order.algoliaOrderUpdates && Array.isArray(this.props.order.algoliaOrderUpdates)) {

            // console.log("upx7785 props.orderUpdates " + " " + this.props.order.order_num);
            // console.log("upx77851 props.orderUpdates :" + " " + JSON.stringify(this.props.order.algoliaOrderUpdates, null, 3));
            // console.log("upx77852 this.state.updates " + " " + this.state.updates.length);

            // updates = this.getOrderUpdateUi(this.props.order.algoliaOrderUpdates);


            let nonNullArray = this.props.order.algoliaOrderUpdates.filter(function(update) {
                return update != null;
              });

              //console.log("upx77853 nonNullArray size is now:"+nonNullArray.length)

            //updates = this.state.updates.map((update) =>
            updates = nonNullArray.map((update) =>

                <ShowFeedUi key={update.time} update={update} />
            );
        } else {
            //console.log("upx7784 no updates");
            updates = <h4> CLICK VIEW TO SEE UPDATES </h4>
        }

        const showRefreshing = this.props.awaitingRefresh
        ?<h5>LOADING</h5>
        :''

        return (
            <div>
                <Feed>
                    {updates}
                </Feed>
                {/* <Button color='green' onClick={props.syncOrderUpdates}>VIEW UPDATES</Button> */}
                {/* <Button color='green' onClick={this.props.setRefreshToTrue}>REFRESH TRUE</Button>
                <Button color='red' onClick={this.props.setRefreshToFalse}>REFRESH FALSE</Button> */}
                {showRefreshing}

                {/* <Form>
                    <Form.Input onChange={this.handleTextChange} name="updateText" value={this.state.updateText} placeholder='Update Order' />
                    <Form.Button onClick={this.updateCommentFormSubmit}> UPDATE orde algolia</Form.Button>
                </Form> */}
            </div>

        )
    }
}

export default AlogoliaOrderUpdateFeed;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/algoliaDashboard/AlogoliaOrderUpdateFeed.js